import React from 'react'
import { Flex, Spacer, Text } from '@sendoutcards/quantum-design-ui'

const MainInfo: React.FC = () => {
  return (
    <Flex flexDirection="column" alignItems="center">
      <Spacer space="x4" />
      <Text type="body">
        SendOutCards uses points and expense to pay for greeting cards and
        gifts, which saves you time and money. You can also purchase single
        cards and stamps each time you use the service. Click on the single card
        purchase below and add expense if you choose to purchase one card at a
        time.
      </Text>
      <Spacer space="x4" />
    </Flex>
  )
}

export default MainInfo
